import {TranslatableRental} from "./locations";
import {mainPhotoStudio1, studio1Photos} from "./photo";
import {studio1FR} from "./descriptions/fr/studio1";
import {studio1EN} from "./descriptions/en/studio1";



export const studio1: TranslatableRental = {
  roomId: "501224",
  slugs: {
    fr: "studio-vue-jardin",
    en: "garden-view-studio"
  },
  name: {
    fr: "Studio 2 personnes",
    en: "Studio for 2 people"
  },
  area: 30,
  capacity: 2,
  numberOfBeds: 1,
  numberOfBedrooms: 1,
  numberOfBathrooms: 1,
  description: {
    fr: studio1FR,
    en: studio1EN
  },
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "coffee-machine",
    "fridge",
    "heater",
    "kitchen-storage",
    "swimming",
    "toilet",
    "shower",
    "wheelchair-way",
    "parking",
    "kettle",
    "microwave",
    "no-smoking",
    "hair-dryer",
    "iron",
    "household-linen",
    "toaster"
  ],
  lodgifyId: "435087",
  assets: studio1Photos,
  mainImage: mainPhotoStudio1
};
